import type {
  Categories,
  CreateWrapperSettings
} from "@segment/analytics-consent-tools"
import { ConsentBus } from "cookiesConsent/infrastructure/segment/ConsentBus"

export class SegmentConsentSettings implements CreateWrapperSettings {
  private readonly bus: ConsentBus

  constructor(bus: ConsentBus) {
    this.bus = bus
  }

  getCategories = (): Categories => this.bus.snapshot().forSegment()

  registerOnConsentChanged = (
    notify: (categories: Categories) => void
  ): void => {
    this.bus.subscribe(next => notify(next.forSegment()))
  }
}
